import { render, staticRenderFns } from "./ShowGridTranslator.vue?vue&type=template&id=3a5112f6&scoped=true"
import script from "./ShowGridTranslator.vue?vue&type=script&lang=js"
export * from "./ShowGridTranslator.vue?vue&type=script&lang=js"
import style0 from "./ShowGridTranslator.vue?vue&type=style&index=0&id=3a5112f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5112f6",
  null
  
)

export default component.exports